export default {"src":"/_next/static/media/success.61b966ac.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};